export const phasesKeys = {
  all: ["phases"] as const,
  list: () => [...phasesKeys.all, "list"] as const,
  current: () => [...phasesKeys.all, "current"] as const,
  detail: (id: string) => [...phasesKeys.all, "detail", id] as const,
};
